<template>
  <gmap-map
    :center="center"
    :zoom="17"
    style="width: 100%; height: 100%"
  >
    <gmap-marker
      v-for="m in markers"
      :position="m.position"
      :clickable="true"
      :draggable="true"
      @click="center=m.position"
    ></gmap-marker>
  </gmap-map>
</template>

<script>
  /////////////////////////////////////////
  // New in 0.4.0
  import * as VueGoogleMaps from 'vue2-google-maps';
  import Vue from 'vue';

  Vue.use(VueGoogleMaps, {
    load: {
      key: 'AIzaSyCJfGbecfuKpEMJiDHyzW234fVEjEjcUpU',
      v: '3.27'
      // libraries: 'places', //// If you need to use place input
    }
  });
  export default {
    data() {
      return {
        center: {lat: -6.2256158, lng: 106.8101348},
        markers: [{
          position: {lat: -6.2256158, lng: 106.8101348}
        }]
      };
    }
  };
</script>


// WEBPACK FOOTER //
// Maps.vue?33e59296